"use client";

import { retriveBooking } from "api/booking/booking";
import {
  getCompanyInfoFun,
  getWebInfo,
  getWebsiteSectionInfo,
} from "api/company/company";
import { applyCoupon, removeCoupon } from "api/coupon/coupon";
import { getLocationData } from "api/locations/locations";
import { CreateStripeIntent, SavePaymentMethod } from "api/stripe/stripe";
import { VehiclePayload, VehicleResponse } from "api/types";
import { getAvailableVehicleData, getVehicleData } from "api/vehicles/vehicle";
import { LocationListingModal } from "models/LocationModal";
import { User } from "models/userModal";
import { CarListingModal } from "models/vehicleModal";
import moment from "moment";
import React, { createContext, useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";

interface BonzahProduct {
  name: string;
  productType: string;
  currency: string;
  regularPrice: number;
  discountPercent: number;
  finalPrice: number;
  totalPrice: number;
  numberOfDays: number;
  priceBasis: string;
  supplier: string;
  isSelected?: boolean;
  productInfo: {
    descriptionOfCoverageUrl: string;
  };
  additionalInfo?: Record<string, any>;
}
interface DataContextType {
  user: User | null;
  setUser: React.Dispatch<React.SetStateAction<User | null>>;
  ourVehicles: CarListingModal[];
  setOurVehicles: React.Dispatch<React.SetStateAction<CarListingModal[]>>;
  ourVehiclesLoading: boolean;
  ourLocation: LocationListingModal[];
  setOurLocation: React.Dispatch<React.SetStateAction<LocationListingModal[]>>;
  ourCompany: any;
  setOurCompany: React.Dispatch<React.SetStateAction<any>>;
  companyDetails: any;
  setCompanyDetails: React.Dispatch<React.SetStateAction<any>>;
  banner: any;
  aboutUs: any;
  whyUs: any;
  socialItems: any;
  address: any;
  contactItems: any;
  footerItems: any;
  testimonials: any;
  faqs: any;
  popUp: any;
  setPopUp: React.Dispatch<React.SetStateAction<any>>;
  pickupLocation: any;
  setPickupLocation: React.Dispatch<
    React.SetStateAction<LocationListingModal | null>
  >;
  stripeVerificationLoading: boolean;
  setStripeVerificationLoading: React.Dispatch<React.SetStateAction<boolean>>;
  dropOffLocation: any;
  setDropoffLocation: React.Dispatch<
    React.SetStateAction<LocationListingModal | null>
  >;
  dropoffLocationType: boolean;
  setDropoffLocationType: React.Dispatch<React.SetStateAction<boolean>>;
  sameDropoffLocation: boolean;
  setSameDropoffLocation: React.Dispatch<React.SetStateAction<boolean>>;
  bookingdetails: any;
  setBookingdetails: React.Dispatch<React.SetStateAction<any>>;
  invoice: any;
  setInvoice: React.Dispatch<React.SetStateAction<any>>;
  availableFleet: VehicleResponse[] | null;
  loadingAvailableFleet: boolean;
  isAuthPanelOpen: boolean;
  extras: any;
  setExtras: React.Dispatch<React.SetStateAction<[]>>;
  selectedExtras: any;
  setSelectedExtras: React.Dispatch<React.SetStateAction<Set<number>>>;
  selectedBonzahProducts: any;
  setSelectedBonzahProducts: React.Dispatch<React.SetStateAction<Set<any>>>;
  selectedBonzahAddOns: any;
  setSelectedBonzahAddOns: React.Dispatch<React.SetStateAction<Set<any>>>;
  bonzahProducts: any;
  setBonzahProducts: React.Dispatch<React.SetStateAction<BonzahProduct[]>>;
  setIsAuthPanelOpen: React.Dispatch<React.SetStateAction<boolean>>;
  searchedPickupLoction: string;
  checkCouponResponseLoading: boolean;
  setCheckCouponResponseLoading: React.Dispatch<React.SetStateAction<boolean>>;
  loadingCompanyDetails: boolean;
  unavailable: boolean;
  allBookings: any;
  setAllBookings: React.Dispatch<React.SetStateAction<any>>;
  setUnavailable: React.Dispatch<React.SetStateAction<boolean>>;
  setSearchedPickupLocation: React.Dispatch<React.SetStateAction<string>>;
  couponResponse: any;
  searchedDropoffLocation: string;
  setSearchedDropoffLocation: React.Dispatch<React.SetStateAction<string>>;
  setCouponResponse: React.Dispatch<React.SetStateAction<any>>;
  callCouponAPI: (couponCode: string, bookingId: string) => Promise<void>;
  callremoveCouponAPI: (couponCode: string, bookingId: string) => Promise<void>;
  selectedCar: CarListingModal | null;
  setSelectedCar: React.Dispatch<React.SetStateAction<CarListingModal | null>>;
  callAvailableFleetAPI: (navigate: any) => Promise<void>;
  checkout: (bookingId: any) => Promise<any>;
  saveCard: (paymentMethodId: any) => Promise<any>;

  startDate: Date | null;
  startHours: string;
  startMinutes: string;
  startPeriod: string;
  endDate: Date | null;
  endHours: string;
  endMinutes: string;
  endPeriod: string;
  setStartTime: React.Dispatch<React.SetStateAction<string>>;
  setEndTime: React.Dispatch<React.SetStateAction<string>>;
  s_Time: string;
  e_Time: string;
  setIsLongTermRental: React.Dispatch<React.SetStateAction<boolean>>;
  is_long_term_rental: boolean;
  setLongTermRentalNature: React.Dispatch<React.SetStateAction<string>>;
  long_term_rental_nature: string;
  setLongTermRentalDuration: React.Dispatch<React.SetStateAction<number>>;
  long_term_rental_duration: number;
  startTime: string;
  endTime: string;
  partiallyAvailableStartDate: Date | null;
  partiallyAvailableEndDate: Date | null;
  activeTab: string;
  setActiveTab: React.Dispatch<React.SetStateAction<string>>;
  selectedWeeks: string[];
  setSelectedWeeks: React.Dispatch<React.SetStateAction<string[]>>;
  weeksViewMonth: Date;
  setWeeksViewMonth: React.Dispatch<React.SetStateAction<Date>>;
  selectedMonth: number;
  setSelectedMonth: React.Dispatch<React.SetStateAction<number>>;
  monthStartDate: Date;
  setMonthStartDate: React.Dispatch<React.SetStateAction<Date>>;
  monthEndDate: Date;
  setMonthEndDate: React.Dispatch<React.SetStateAction<Date>>;

  driverFirstName: string;
  setDriverFirstName: React.Dispatch<React.SetStateAction<string>>;
  driverLastName: string;
  setDriverLastName: React.Dispatch<React.SetStateAction<string>>;
  driverEmail: string;
  setDriverEmail: React.Dispatch<React.SetStateAction<string>>;
  driverPhone: string;
  setDriverPhone: React.Dispatch<React.SetStateAction<string>>;

  firstName: string;
  setFirstName: React.Dispatch<React.SetStateAction<string>>;
  lastName: string;
  setLastName: React.Dispatch<React.SetStateAction<string>>;
  email: string;
  setEmail: React.Dispatch<React.SetStateAction<string>>;
  phone: string;
  setPhone: React.Dispatch<React.SetStateAction<string>>;

  setStartDate: React.Dispatch<React.SetStateAction<Date | null>>;
  setStartHours: React.Dispatch<React.SetStateAction<string>>;
  setStartMinutes: React.Dispatch<React.SetStateAction<string>>;
  setStartPeriod: React.Dispatch<React.SetStateAction<string>>;
  setEndDate: React.Dispatch<React.SetStateAction<Date | null>>;
  setEndHours: React.Dispatch<React.SetStateAction<string>>;
  setEndMinutes: React.Dispatch<React.SetStateAction<string>>;
  setEndPeriod: React.Dispatch<React.SetStateAction<string>>;
  setPartiallyAvailableStartDate: React.Dispatch<
    React.SetStateAction<Date | null>
  >;
  setPartiallyAvailableEndDate: React.Dispatch<
    React.SetStateAction<Date | null>
  >;

  partiallyUnavailableTimes: { [key: string]: { from?: string; to?: string } };
  setPartiallyUnavailableTimes: React.Dispatch<
    React.SetStateAction<{ [key: string]: { from?: string; to?: string } }>
  >;
}

const DataContext = createContext<DataContextType | undefined>(undefined);

export const formatDateTime = (
  date: Date | null | undefined, // Allow null and undefined
  time: string,
): string => {
  return moment(date).format("YYYY-MM-DD") + "T" + time + ":00";
};

export function DataProvider({ children }: any) {
  const [user, setUser] = useState<User | null>(null);
  const [ourVehicles, setOurVehicles] = useState<CarListingModal[]>([]);
  const [ourLocation, setOurLocation] = useState<LocationListingModal[]>([]);
  const [ourCompany, setOurCompany] = useState<any>([]);
  const [companyDetails, setCompanyDetails] = useState<any>();
  const [banner, setBanner] = useState<any>();
  const [aboutUs, setAboutUs] = useState<any>();
  const [whyUs, setWhyUs] = useState<any>();
  const [testimonials, setTestimonials] = useState<any>();
  const [faqs, setFaqs] = useState<any>();
  const [popUp, setPopUp] = useState<any>();

  const [socialItems, setsocialItems] = useState<any>([]);
  const [address, setAddress] = useState<any>([]);
  const [contactItems, setContactItems] = useState<any>([]);
  const [footerItems, setFooterItems] = useState<any>([]);
  const [pickupLocation, setPickupLocation] =
    useState<LocationListingModal | null>(null);
  const [dropOffLocation, setDropoffLocation] =
    useState<LocationListingModal | null>(null);
  const [searchedPickupLoction, setSearchedPickupLocation] =
    useState<string>("");
  const [searchedDropoffLocation, setSearchedDropoffLocation] =
    useState<string>("");
  const [ourVehiclesLoading, setOurVehiclesLoading] = useState<boolean>(false);
  const [dropoffLocationType, setDropoffLocationType] = useState<boolean>(true);
  const [sameDropoffLocation, setSameDropoffLocation] = useState<boolean>(true);
  const [isAuthPanelOpen, setIsAuthPanelOpen] = useState<boolean>(false);
  const [couponResponse, setCouponResponse] = useState<any>(null);
  const [checkCouponResponseLoading, setCheckCouponResponseLoading] =
    useState<boolean>(false);
  const [stripeVerificationLoading, setStripeVerificationLoading] =
    useState<boolean>(false);
  const [unavailable, setUnavailable] = useState<boolean>(false);
  const [selectedCar, setSelectedCar] = useState<CarListingModal | null>(null);
  const [bookingdetails, setBookingdetails] = useState<any>(null);
  const [invoice, setInvoice] = useState<any>([]);
  const [extras, setExtras] = useState<any>([]);
  const [selectedExtras, setSelectedExtras] = useState<Set<number>>(new Set());
  const [allBookings, setAllBookings] = useState<any>();
  const [selectedBonzahProducts, setSelectedBonzahProducts] = useState<
    Set<any>
  >(new Set());
  const [selectedBonzahAddOns, setSelectedBonzahAddOns] = useState<Set<any>>(
    new Set(),
  );

  const [bonzahProducts, setBonzahProducts] = useState<BonzahProduct[]>([]);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [driverFirstName, setDriverFirstName] = useState("");
  const [driverLastName, setDriverLastName] = useState("");
  const [driverEmail, setDriverEmail] = useState("");
  const [driverPhone, setDriverPhone] = useState("");
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [partiallyAvailableStartDate, setPartiallyAvailableStartDate] =
    useState<Date | null>(null);
  const [partiallyAvailableEndDate, setPartiallyAvailableEndDate] =
    useState<Date | null>(null);
  const [startHours, setStartHours] = useState("07");
  const [startMinutes, setStartMinutes] = useState("00");
  const [startPeriod, setStartPeriod] = useState("AM");
  const [activeTab, setActiveTab] = useState("dates");
  const [endHours, setEndHours] = useState("07");
  const [endMinutes, setEndMinutes] = useState("00");
  const [endPeriod, setEndPeriod] = useState("PM");
  const [selectedWeeks, setSelectedWeeks] = useState<string[]>([]);
  const [weeksViewMonth, setWeeksViewMonth] = useState<Date>(new Date());
  const [selectedMonth, setSelectedMonth] = useState<number>(0);
  const [monthStartDate, setMonthStartDate] = useState<Date>(new Date());
  const [monthEndDate, setMonthEndDate] = useState<Date>(
    moment().add(1, "months").toDate(),
  );

  const [availableFleet, setAvailableFleet] = useState<VehicleResponse[]>([]);
  const [loadingAvailableFleet, setLoadingAvailableFleet] =
    useState<boolean>(false);
  const [loadingCompanyDetails, setLoadingCompanyDetails] =
    useState<boolean>(true);
  const [partiallyUnavailableTimes, setPartiallyUnavailableTimes] = useState<{
    [key: string]: { from?: string; to?: string };
  }>({});
  const [is_long_term_rental, setIsLongTermRental] = useState<boolean>(true);
  const [long_term_rental_nature, setLongTermRentalNature] =
    useState<string>("daily");
  const [long_term_rental_duration, setLongTermRentalDuration] =
    useState<number>(0);

  const s_Time = "07:00";
  const e_Time = "19:00";
  const [startTime, setStartTime] = useState(
    startDate ? moment(startDate).format("HH:mm") : s_Time,
  );
  const [endTime, setEndTime] = useState(
    endDate ? moment(endDate).format("HH:mm") : e_Time,
  );

  useEffect(() => {
    apiCalls();
  }, []);

  useEffect(() => {
    if (selectedCar) {
      if (
        selectedCar.fleet_photos.length === 0 ||
        selectedCar.thumbnail_photo === null ||
        selectedCar.thumbnail_photo === selectedCar?.fleet_photos[0]?.id
      )
        return;
      const sortedPhotos = selectedCar.fleet_photos.sort((a, b) => {
        if (a.id === selectedCar.thumbnail_photo) return -1;
        if (b.id === selectedCar.thumbnail_photo) return 1;
        return 0;
      });

      setSelectedCar({ ...selectedCar, fleet_photos: sortedPhotos });
    }
  }, [selectedCar]);

  // Load user data from localStorage
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      try {
        setUser(JSON.parse(storedUser));
      } catch (error) {
        console.error("Failed to parse user data:", error);
      }
    }
  }, []);

  const callOurVehicleAPI = async () => {
    setOurVehiclesLoading(true);
    try {
      const today = new Date();
      const firstDayOfMonth = `${today.getFullYear()}-${String(
        today.getMonth() + 1,
      ).padStart(2, "0")}-01`;
      const lastDay = new Date(
        today.getFullYear(),
        today.getMonth() + 1,
        0,
      ).getDate();
      const lastDayOfMonth = `${today.getFullYear()}-${String(
        today.getMonth() + 1,
      ).padStart(2, "0")}-${String(lastDay).padStart(2, "0")}`;
      const payload: any = {
        start_time: firstDayOfMonth,
        end_time: lastDayOfMonth,
      };

      const data = await getVehicleData(payload);

      if (Array.isArray(data)) {
        setOurVehicles(
          data.filter((vehicle) => vehicle.active) as CarListingModal[],
        );
      } else if (data?.data && Array.isArray(data.data)) {
        setOurVehicles(
          data.data.filter((vehicle) => vehicle.active) as CarListingModal[],
        );
      } else {
        throw new Error("Invalid data format");
      }
    } catch (error: any) {
      toast.error(error.message || "Failed to fetch vehicles");
      console.error("Vehicle API error:", error);
    } finally {
      setOurVehiclesLoading(false);
    }
  };

  const callAvailableFleetAPI = async (navigate: (path: string) => void) => {
    setLoadingAvailableFleet(true);

    if (startDate === null) {
      toast.error("Start date is not set");
      setLoadingAvailableFleet(false);
      return;
    }

    if (endDate === null) {
      toast.error("End date is not set");
      setLoadingAvailableFleet(false);
      return;
    }

    if (!startTime) {
      toast.error("Start time is not set");
      setLoadingAvailableFleet(false);
      return;
    }

    if (!endTime) {
      toast.error("End time is not set");
      setLoadingAvailableFleet(false);
      return;
    }

    const vehiclePayload: VehiclePayload = {
      available: true,
      start_time: formatDateTime(startDate, startTime),
      end_time: formatDateTime(endDate, endTime),
      pickup_location: pickupLocation?.id,
      booking_id: bookingdetails?.id,
      is_long_term_rental : is_long_term_rental,
      long_term_rental_nature : long_term_rental_nature,
    };

    // Helper function to transform CarListingModal to VehicleResponse
    const transformCarListingToVehicleResponse = (
      carListing: CarListingModal[],
    ): VehicleResponse[] => {
      return carListing.map((car) => ({
        ...car,
      }));
    };

    try {
      const result = await getAvailableVehicleData(vehiclePayload);

      setLoadingAvailableFleet(false);

      if (result.error) {
        setLoadingAvailableFleet(false);
      } else if (result.data) {
        // Filter for active vehicles before transforming the result
        const activeVehicles = (result.data as CarListingModal[]).filter(
          (vehicle) => vehicle.active,
        );
        setAvailableFleet(transformCarListingToVehicleResponse(activeVehicles));
        navigate("/available-car");
      }
    } catch (error) {
      console.error("An unexpected error occurred:", error);
      setLoadingAvailableFleet(false);
    } finally {
      setLoadingAvailableFleet(false);
    }
  };

  const callCouponAPI = async (couponCode: string, bookingId: string) => {
    try {
      setCheckCouponResponseLoading(true);
      const data: any = await applyCoupon(couponCode, bookingId);
      if (data?.error?.length > 0) {
        toast.error(data?.error);
      } else {
        setCouponResponse(data as any);

        if (data) {
          const response: any = await retriveBooking(bookingId);
          setBookingdetails(response);
        }
      }
    } catch (error: any) {
      toast.error("Invalid Promo Code"); // Or handle errors in a more sophisticated way
    } finally {
      setCheckCouponResponseLoading(false);
    }
  };
  const callremoveCouponAPI = async (couponCode: string, bookingId: string) => {
    try {
      const data: any = await removeCoupon(couponCode, bookingId);

      if (data) {
        const response: any = await retriveBooking(bookingId);
        setBookingdetails(response);
      }
    } catch (error: any) {
      toast.error("Error occur removing Promo Code"); // Or handle errors in a more sophisticated way
    } finally {
    }
  };

  const saveCard = async (
    paymentMethodId: any,
  ): Promise<{ data?: any; error?: string } | undefined> => {
    const payload = { payment_method_id: paymentMethodId };
    try {
      const res = await SavePaymentMethod(payload);
      return res; // Return the result which can have data or error
    } catch (error: any) {
      toast.error(error.message || "Failed to save the payment method");
      console.error("Save Card error:", error);
      return undefined; // Return undefined in case of an error
    }
  };

  const checkout = async (
    bookingId: any,
  ): Promise<{ data?: any; error?: string } | undefined> => {
    const payload = { booking_id: bookingId };

    try {
      const res = await CreateStripeIntent(payload);
      return res; // Return the result which can have data or error
    } catch (error: any) {
      toast.error(error.message || "Failed to process checkout");
      console.error("Checkout error:", error);
      return undefined; // Return undefined in case of an error
    }
  };

  // Fetch location data from API
  const callOurLocationAPI = async () => {
    try {
      const data = await getLocationData();
      if (Array.isArray(data)) {
        const locations = data as LocationListingModal[];
        setOurLocation(locations);
        const activeLocations = locations.filter((loc) => loc.active !== false);
        if (activeLocations.length === 1) {
          setPickupLocation(activeLocations[0]);
          setDropoffLocation(activeLocations[0]);
        }
      } else {
        throw new Error("Unable to fetch location data");
      }
    } catch (error: any) {
      toast.error(error.message || "Failed to fetch locations");
      console.error("Location API error:", error);
    }
  };

  const apiCalls = async () => {
    callOurCompanyDetails();
    callOurVehicleAPI();
    callOurLocationAPI();
    callOurCompanyAPI();
    callWebsiteSectionsAPI();
  };

  const changeFavicon = (url: any) => {
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement("link");
      (link as HTMLLinkElement).rel = "icon";
      document.head.appendChild(link);
    }
    (link as HTMLLinkElement).href = url;
  };

  const callOurCompanyDetails = async () => {
    try {
      const data = await getWebInfo();
      setCompanyDetails(data);
      changeFavicon(data?.favicon_image);
      let fontName = data?.font_family ?? "Urbanist";
      fontName = fontName === "" ? "Urbanist" : fontName;
      const root = document.documentElement;
      const bannerHeadingColor = data?.banner_heading_color || "#ffffff";
      const bannerDescriptionColor =
        data?.banner_description_color || "#ffffff";
      const bgColor = data?.bg_color || "#000000";
      const primaryColor = data?.primary_color || "#000000";
      const secondaryColor = data?.component_bg_color || "#000000";
      const secondaryTextColor = data?.secondary_text_color || "#000000";
      const navigationTextColor = data?.navigation_text_color || "#000000";
      const textColor = data?.text_color || "#ffffff";
      const descriptionColor = data?.description_color || "#ffffff";
      const buttonColor = data?.button_color || "#3d5afe";

      const hexToRgb = (hex: string) => {
        const bigint = parseInt(hex.slice(1), 16);
        const r = (bigint >> 16) & 255;
        const g = (bigint >> 8) & 255;
        const b = bigint & 255;
        return `${r}, ${g}, ${b}`;
      };

      const bannerHeadingColorRgb = hexToRgb(bannerHeadingColor);
      const bannerDescriptionColorRgb = hexToRgb(bannerDescriptionColor);
      const bgColorRgb = hexToRgb(bgColor);
      const primaryColorRgb = hexToRgb(primaryColor);
      const secondaryColorRgb = hexToRgb(secondaryColor);
      const secondaryTextColorRgb = hexToRgb(secondaryTextColor);
      const navigationTextColorRgb = hexToRgb(navigationTextColor);
      const textColorRgb = hexToRgb(textColor);
      const descriptionColorRgb = hexToRgb(descriptionColor);
      const buttonColorRgb = hexToRgb(buttonColor);
      root.style.setProperty("--c-banner-heading-color", bannerHeadingColorRgb);
      root.style.setProperty(
        "--c-banner-description-color",
        bannerDescriptionColorRgb,
      );
      root.style.setProperty("--c-primary-50", "255, 255, 255");
      root.style.setProperty("--c-primary-100", primaryColorRgb);
      root.style.setProperty("--c-primary-200", primaryColorRgb);
      root.style.setProperty("--c-primary-300", primaryColorRgb);
      root.style.setProperty("--c-primary-400", primaryColorRgb);
      root.style.setProperty("--c-primary-500", primaryColorRgb);
      root.style.setProperty("--c-primary-600", primaryColorRgb);
      root.style.setProperty("--c-primary-700", primaryColorRgb);
      root.style.setProperty("--c-primary-800", primaryColorRgb);
      root.style.setProperty("--c-primary-900", primaryColorRgb);
      root.style.setProperty("--c-secondary-50", secondaryColorRgb);
      root.style.setProperty("--c-secondary-100", secondaryColorRgb);
      root.style.setProperty("--c-secondary-200", secondaryColorRgb);
      root.style.setProperty("--c-secondary-300", secondaryColorRgb);
      root.style.setProperty("--c-secondary-400", secondaryColorRgb);
      root.style.setProperty("--c-secondary-500", secondaryColorRgb);
      root.style.setProperty("--c-secondary-600", secondaryColorRgb);
      root.style.setProperty("--c-secondary-700", secondaryColorRgb);
      root.style.setProperty("--c-secondary-800", secondaryColorRgb);
      root.style.setProperty("--c-secondary-900", secondaryColorRgb);
      root.style.setProperty("--c-bg-color", bgColorRgb);
      root.style.setProperty("--c-button-color", buttonColorRgb);
      root.style.setProperty("--c-text-color", textColorRgb);
      root.style.setProperty("--c-description-color", descriptionColorRgb);
      root.style.setProperty("--c-secondary-text-color", secondaryTextColorRgb);
      root.style.setProperty(
        "--c-navigation-text-color",
        navigationTextColorRgb,
      );
      document.documentElement.style.setProperty("--font-body", fontName);
      document.documentElement.style.setProperty("--font-display", fontName);
      // Optionally load the Google Font dynamically
      const formattedFont = fontName.replace(/\s+/g, "+");
      const fontUrl = `https://fonts.googleapis.com/css2?family=${formattedFont}:wght@100;200;300;400;500;600;700;800;900&display=swap`;

      let link = document.querySelector("#dynamic-font");
      if (!link) {
        link = document.createElement("link");
        link.id = "dynamic-font";
        (link as HTMLLinkElement).rel = "stylesheet";
        document.head.appendChild(link);
      }
      (link as HTMLLinkElement).href = fontUrl;
      if (data?.google_analytics_id) {
        const existingGtagScript = document.querySelector("#gtag-script");
        const existingGtagInit = document.querySelector("#gtag-init");
        if (existingGtagScript) existingGtagScript.remove();
        if (existingGtagInit) existingGtagInit.remove();
        const gtagScript = document.createElement("script");
        gtagScript.id = "gtag-script";
        gtagScript.async = true;
        gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${data.google_analytics_id}`;
        document.head.appendChild(gtagScript);
        const gtagInit = document.createElement("script");
        gtagInit.id = "gtag-init";
        gtagInit.innerHTML = `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${data.google_analytics_id}');
        `;
        document.head.appendChild(gtagInit);
      }
    } catch (error: any) {
      toast.error(error.message || "Failed to fetch company details");
      console.error("Company Details API error:", error);
    } finally {
      setLoadingCompanyDetails(false);
    }
  };
  const callOurCompanyAPI = async () => {
    try {
      const data = await getCompanyInfoFun();

      setOurCompany(data);
    } catch (error: any) {
      toast.error(error.message || "Failed to fetch company");
      console.error("Company API error:", error);
    }
  };

  const callWebsiteSectionsAPI = async () => {
    try {
      const sections = await getWebsiteSectionInfo();
      sections?.forEach((section: any) => {
        switch (section.section_type) {
          case "about-us":
            setAboutUs(section);
            break;
          case "banner":
            setBanner(section);
            break;
          case "faqs":
            setFaqs(section);
            break;
          case "pop-up":
            setPopUp(section);
            break;
          case "testimonials":
            setTestimonials(section);
            break;
          case "why-us":
            setWhyUs(section);
            break;
          case "footer":
            let socialItemsList: any = [];
            let contactItemsList: any = [];
            let addressItemsList: any = [];
            let footerItemsList: any = [];
            section?.keypoints?.forEach((keypoint: any, index: number) => {
              if (keypoint?.keypoint_type === "social_items") {
                socialItemsList.push({
                  index: index,
                  id: keypoint.id.toString(),
                  heading: keypoint.heading,
                  description: keypoint.description,
                  image_url: keypoint.image_url,
                  keypoint_type: keypoint.keypoint_type,
                });
              } else if (keypoint?.keypoint_type === "contact_items") {
                contactItemsList.push({
                  index: index,
                  id: keypoint.id.toString(),
                  heading: keypoint.heading,
                  description: keypoint.description,
                  image_url: keypoint.image_url,
                  keypoint_type: keypoint.keypoint_type,
                });
              } else if (keypoint?.keypoint_type === "address_items") {
                addressItemsList.push({
                  index: index,
                  id: keypoint.id.toString(),
                  heading: keypoint.heading,
                  description: keypoint.description,
                  image_url: keypoint.image_url,
                  keypoint_type: keypoint.keypoint_type,
                });
              } else {
                footerItemsList.push({
                  index: index,
                  id: keypoint.id.toString(),
                  heading: keypoint.heading,
                  description: keypoint.description,
                  image_url: keypoint.image_url,
                  keypoint_type: keypoint.keypoint_type,
                });
              }
            });
            setsocialItems(socialItemsList);
            setContactItems(contactItemsList);
            setAddress(addressItemsList);
            setFooterItems(footerItemsList);
            break;
          default:
            break;
        }
      });
    } catch (error: any) {
      toast.error(error.message || "Failed to fetch about us info");
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (selectedCar && selectedCar.id) {
      params.delete(String(selectedCar.id));
      params.set("selectedCarId", String(selectedCar.id));
    } else {
      Array.from(params.keys()).forEach((key) => {
        if (/^\d+$/.test(key)) params.delete(key);
      });
    }

    const newUrl =
      window.location.pathname +
      (params.toString() ? `?${params.toString()}` : "");
    if (window.location.search !== `?${params.toString()}`) {
      window.history.replaceState({}, "", newUrl);
    }
  }, [selectedCar]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const carIdParam = params.get("selectedCarId");

    if (carIdParam) {
      if (!selectedCar || String(selectedCar.id) !== carIdParam) {
        const car = ourVehicles.find((v) => String(v.id) === carIdParam);

        if (car) {
          setSelectedCar(car);
        } else if (ourVehicles.length > 0) {
          window.location.replace("/");
        }
      }
    } else if (selectedCar) {
      setSelectedCar(null);
    }
  }, [window.location.search, ourVehicles]);

  return (
    <DataContext.Provider
      value={{
        user,
        setUser,
        ourVehicles,
        setOurVehicles,
        ourVehiclesLoading,
        isAuthPanelOpen,
        setIsAuthPanelOpen,
        ourLocation,
        loadingCompanyDetails,
        checkCouponResponseLoading,
        setCheckCouponResponseLoading,
        couponResponse,
        selectedExtras,
        setSelectedExtras,
        selectedBonzahProducts,
        setSelectedBonzahProducts,
        selectedBonzahAddOns,
        setSelectedBonzahAddOns,
        setOurLocation,
        bookingdetails,
        setBookingdetails,
        ourCompany,
        setOurCompany,
        companyDetails,
        setCompanyDetails,
        banner,
        aboutUs,
        whyUs,
        socialItems,
        address,
        contactItems,
        footerItems,
        testimonials,
        faqs,
        setPopUp,
        popUp,
        extras,
        setExtras,
        setBonzahProducts,
        bonzahProducts,
        setCouponResponse,
        availableFleet,
        allBookings,
        setAllBookings,
        pickupLocation,
        unavailable,
        setUnavailable,
        sameDropoffLocation,
        setSameDropoffLocation,
        setPickupLocation,
        dropOffLocation,
        setDropoffLocation,
        searchedDropoffLocation,
        setStripeVerificationLoading,
        stripeVerificationLoading,
        searchedPickupLoction,
        setSearchedDropoffLocation,
        firstName,
        lastName,
        email,
        phone,
        setFirstName,
        setLastName,
        setEmail,
        setPhone,
        driverEmail,
        setDriverEmail,
        driverFirstName,
        driverLastName,
        driverPhone,
        setDriverFirstName,
        setDriverLastName,
        setDriverPhone,
        setSearchedPickupLocation,
        dropoffLocationType,
        setDropoffLocationType,
        invoice,
        setInvoice,
        loadingAvailableFleet,
        callCouponAPI,
        callremoveCouponAPI,
        selectedCar,
        setSelectedCar,
        callAvailableFleetAPI,
        startDate,
        startMinutes,
        startHours,
        startPeriod,
        activeTab,
        setActiveTab,
        saveCard,
        endDate,
        endMinutes,
        endPeriod,
        partiallyAvailableStartDate,
        partiallyAvailableEndDate,
        endHours,
        setStartDate,
        setStartHours,
        checkout,
        setStartMinutes,
        setStartPeriod,
        setEndDate,
        setEndHours,
        setEndMinutes,
        setEndPeriod,
        setEndTime,
        setStartTime,
        startTime,
        endTime,
        s_Time,
        e_Time,
        setIsLongTermRental,
        is_long_term_rental,
        setLongTermRentalNature,
        long_term_rental_nature,
        setLongTermRentalDuration,
        long_term_rental_duration,
        setPartiallyAvailableStartDate,
        setPartiallyAvailableEndDate,
        selectedWeeks,
        setSelectedWeeks,
        weeksViewMonth,
        setWeeksViewMonth,
        selectedMonth,
        setSelectedMonth,
        monthStartDate,
        setMonthStartDate,
        monthEndDate,
        setMonthEndDate,
        partiallyUnavailableTimes,
        setPartiallyUnavailableTimes,
      }}
    >
      {children}
    </DataContext.Provider>
  );
}

export function useData() {
  const context = useContext(DataContext);
  if (context === undefined) {
    throw new Error("useData must be used within a DataProvider");
  }
  return context;
}
